{
  "vendorTableConfig": {
    "columns": [
      {
        "fieldName": "name",
        "displayName": "Vendor Name",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "250px"
        },
        "sortable": true
      },
      {
        "fieldName": "code",
        "displayName": "Vendor Code",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "100px"
        },
        "styleConfig": {
          "type": "badge"
        }
      },
      {
        "fieldName": "active",
        "displayName": "Status",
        "dataType": "BOOLEAN",
        "valueMap": {
          "true": "Active",
          "false": "Inactive"
        },
        "thStyleConfig": {
          "width": "80px"
        },
        "styleConfig": {
          "type": "status"
        }
      },
      {
        "fieldName": "agreementWorkOrderNo",
        "displayName": "Agreement WO No",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "200px"
        }
      },
      {
        "fieldName": "agreementStartDate",
        "displayName": "Agreement Start Date",
        "dataType": "DATE",
        "thStyleConfig": {
          "width": "100px"
        }
      },
      {
        "fieldName": "agreementEndDate",
        "displayName": "Agreement End Date",
        "dataType": "DATE",
        "thStyleConfig": {
          "width": "100px"
        }
      },
      {
        "fieldName": "modifiedBy",
        "displayName": "Modified By",
        "dataType": "STRING",
        "hasLookup": true,
        "thStyleConfig": {
          "width": "100px"
        },
        "styleConfig": {
          "type": "user-avatar"
        }
      }
    ]
  },
 "filterConfig": {
    "filterFields": [
      {
        "name": "NAME_CONTAINS",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "NAME_CONTAINS"
        }
      },
  
      {
        "name": "IS_ACTIVE",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "IS_ACTIVE"
        }
      }
    
    ],
    "useNewContract": true
  },
  
  "searchBarConfig": {
    "placeHolder": "Search Vendor by name",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "vendor_name"
      }
    ]
  }
}
